import { PolicyDocumentArchiveResponse } from '@lio/api-types';
import { config } from '@services/config';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useGetPolicyDocumentArchive = (policyId: string | undefined, enabled = true) => {
  const client = useClient();
  const result = useQuery<PolicyDocumentArchiveResponse, Error>({
    queryKey: ['policy', policyId, 'document-archive'],
    queryFn: () => client.get(`policy/${policyId}/document-archive`).json<PolicyDocumentArchiveResponse>(),
    enabled: !!policyId && enabled,
    refetchOnWindowFocus: false,
    ...config,
  });
  return { ...result, archive: result.data };
};
